// extracted by mini-css-extract-plugin
export var modal = "_jb-0";